function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.5 35.5h99v6H.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.5 115.211v8.289h-91V41"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M95.5 44.5v-3m-59.01 5h52.112m-52.112 67h52.112"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.5 113.5V85.693c0-5.479-4.195-9.193-9.256-9.193-5.06 0-9.256 3.715-9.256 9.193 0 2.479-1.374 3.872-3.268 3.872-1.756 0-3.197-1.094-3.197-3.872v-9.018H47.5v9.018c0 5.917 4.083 9.774 9.22 9.774 5.075 0 9.292-3.943 9.292-9.774 0-2.381 1.466-3.291 3.232-3.291 1.766 0 3.233.91 3.233 3.29V113.5H78.5zm-68-66.571v65.142l26 3.36V43.57l-26 3.36zm78 .244v65.658l18 5.494v-76.65l-18 5.498z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 52.415v54.17l17 1.857V50.558l-17 1.857zM15 35.5V35a4.5 4.5 0 014.5-4.5h61A4.5 4.5 0 0185 35v.5M67.5 9.268C67.452 4.414 63.606.5 58.875.5h-1.75C52.365.5 48.5 4.463 48.5 9.359V30.5h4.214V10.054c0-2.981 2.362-5.402 5.28-5.402 2.648 0 4.852 1.997 5.225 4.616h4.28zM66 18.43c1.026-.58 1.5-1.173 1.5-1.764 0-.65-.5-1.893-1.5-3.668-1 1.775-1.5 3.017-1.5 3.668 0 .591.474 1.184 1.5 1.764z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 3,
  x: 61.5,
  y: 9.5,
  rx: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.5 25.5h2v5h-2z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 3,
  x: 57.5,
  y: 22.5,
  rx: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.5 25.5h2v5h-2z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 3,
  x: 31.5,
  y: 22.5,
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 28,
  x: 39.5,
  y: 48.5,
  rx: 6
}));

function SvgRoomSinkKitchenLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 124,
    viewBox: "0 0 107 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSinkKitchenLarge);
export default __webpack_public_path__ + "static/media/RoomSinkKitchenLarge.98f07e7e.svg";
export { ForwardRef as ReactComponent };